import { render } from "./EventCreate.vue?vue&type=template&id=464b12e0&scoped=true"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=464b12e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-464b12e0"

export default script